import React from 'react';
import DashboardLayout from '../../components/layout/DashboardLayout/DashboardLayout';
import './SettingsPage.css';

const SettingsPage = () => {
    return (
        <DashboardLayout>
            <div className="settings-page">
                <h1>Settings</h1>
                <p>Settings functionality coming soon...</p>
            </div>
        </DashboardLayout>
    );
};

export default SettingsPage;